import { required, optional, obj } from 'AppReact/schema';

const address = {
    address: required('string'),
    city: required('string'),
    state: required('string'),
    zip: required('string'),
}

const otherIncome = {
    extra_income_description: optional('string'),
    extra_income: optional('string'),
}

const addressError = {
    addressError: optional('string'),
    cityError: optional('string'),
    stateError: optional('string'),
    zipError: optional('string'),
}

const otherIncomeError = {
    extra_incomeError: optional('string'),
    extra_income_descriptionError: optional('string'),
}

export default {
    id: required('string'),
    employerName: required('string'),
    address: obj(address),
    phoneNumber: required('string'),
    email: required('string'),
    supervisorName: required('string'),
    durationOfEmployment: required('string'),
    monthlyIncome: required('string'),
    extra_income_description: optional('string'),
    extra_income: optional('string'),
    hasExtraIncome: required('boolean'),

    hasError: optional('boolean'),
    employerNameError: optional('string'),
    addressError: obj(addressError),
    phoneNumberError: optional('string'),
    emailError: optional('string'),
    supervisorNameError: optional('string'),
    durationOfEmploymentError: optional('string'),
    monthlyIncomeError: optional('string'),
    extra_incomeError: optional('string'),
    extra_income_descriptionError: optional('string'),
}


export const defaultEmploymentInformation = {
    id: 'leaseholder',
    employerName: '',
    address: {
        address: '',
        city: '',
        state: '',
        zip: ''
      },
    phoneNumber: '',
    email: '',
    supervisorName: '',
    durationOfEmployment: '',
    monthlyIncome: '',
    extra_income: '',
    extra_income_description: '',
    hasExtraIncome: false,

    hasError: false,
    employerNameError: '',
    phoneNumberError: '',
    emailError: '',
    supervisorNameError: '',
    durationOfEmploymentError: '',
    monthlyIncomeError: '',
    addressError: {
        addressError: '',
        cityError: '',
        stateError: '',
        zipError: ''
    },
    extra_incomeError: '',
    extra_income_descriptionError: '',
}
